import * as React from 'react'
import ImageWithText from '../ImageWithText'
import { DynamicSitesCategory } from '../../common/typings/enums'
import { BlogArticlesSectionElement } from './model'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import './style.scss'

export interface BlogArticlesSectionProps {
  blogArticles: BlogArticlesSectionElement[]
}

const sectionStyles = {
  containers: [
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-1 lg:col-end-13',    //row 1
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-1 lg:col-end-9',     //row 2
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-9 lg:col-end-13',    //row 2
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-1 lg:col-end-5',     //row 3
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-5 lg:col-end-9',     //row 3
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-9 lg:col-end-13',    //row 3
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-1 lg:col-end-5',     //row 4
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-5 lg:col-end-13',    //row 4
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-1 lg:col-end-5',     //row 5
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-5 lg:col-end-9',     //row 5
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-9 lg:col-end-13',    //row 5
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-1 lg:col-end-9',     //row 6
    'col-start-1 col-end-13 mb-mobile-l lg:col-start-9 lg:col-end-13',    //row 6
  ],
  images: [
    'h-mobile-xxxl lg:h-xxxxl',    //row 1
    'h-mobile-xxxl lg:h-xxxxl',    //row 2
    'h-mobile-xxxl lg:h-xxxl',     //row 2
    'h-mobile-xxxl lg:h-xxxl',     //row 3
    'h-mobile-xxxl lg:h-xxxxl',    //row 3
    'h-mobile-xxxl lg:h-xxxl',     //row 3
    'h-mobile-xxxl lg:h-xxxl',     //row 4
    'h-mobile-xxxl lg:h-xxxxl',    //row 4
    'h-mobile-xxxl lg:h-xxxl',     //row 5
    'h-mobile-xxxl lg:h-xxxxl',    //row 5
    'h-mobile-xxxl lg:h-xxxl',     //row 5
    'h-mobile-xxxl lg:h-xxxxl',    //row 6
    'h-mobile-xxxl lg:h-xxxl',     //row 6
  ]
}

const ARTICLES_PER_PAGE = 13 //when increased, add styles above

const BlogArticlesSection: React.FC<BlogArticlesSectionProps> = ({
  blogArticles,
}) => {
  const { t } = useTranslation()
  const [articlesToLoad, setArticlesToLoad] = React.useState(ARTICLES_PER_PAGE)
  const [limitedBlogArticles, setLimitedBlogArticles] = React.useState<BlogArticlesSectionElement[]>([])

  React.useEffect(() => {
    setLimitedBlogArticles(blogArticles.slice(0, articlesToLoad))
  }, [blogArticles, articlesToLoad])

  const loadMoreHandler = () => {
    setArticlesToLoad(previousCount => previousCount + ARTICLES_PER_PAGE)
  }
  const articlesRemainToLoad = blogArticles.length - limitedBlogArticles.length

  const category = DynamicSitesCategory.BLOG
  return (
    <section className="BlogArticlesSection GlobSectPadSpacing grid grid-cols-12 gap-x-m mx-0 lg:mx-m">
      {limitedBlogArticles &&
        limitedBlogArticles.map((blogArticle, index) => {
          const slug = `${category}/${(blogArticle.category).replace(/\s+/g, '-').toLowerCase()}`
          return (
            <div className={`${sectionStyles.containers[index % sectionStyles.containers.length]} lg:mb-l`} key={index}>
              <ImageWithText {...blogArticle} style={sectionStyles.images[index % sectionStyles.images.length]} category={slug} />
            </div>
          )
        })
      }
      {!!articlesRemainToLoad && <div
        className="FontS col-span-12 text-center mt-mobile-m mb-mobile-xl lg:mt-l lg:mb-xl cursor-pointer"
        onClick={loadMoreHandler}
      >
        {t('blog:loadMore')} <sup className="text-primary">{articlesRemainToLoad}</sup>
      </div>}
    </section>
  )
}

export default BlogArticlesSection
